const coverageLiabilitiesQuery = `[{
    "deductibleAmount": $deductibleAmount,
    "insuredFamilyComposition": "$insuredFamilyComposition",
    "sumInsured": $liabilitySumInsured
}]`;

export default coverageLiabilitiesQuery;
